<template>
  <div :class="{'is-margin-bottom-xsmall' : currentRouterView !== 'ContactRdvs'}">
    <spinner-round
      :is-loading="loadingRdv"
      v-if="loadingRdv"></spinner-round>
    <div
      v-else
      class="day-event has-background-white">
      <div class="columns is-gapless is-marginless">
        <div class="column is-narrow is-padding-left is-padding-right-large has-text-right is-border-right is-flex">
          <div class=" is-self-centered">
            <p class="is-margin-top-xsmall has-text-centered">
              <time :datetime="date.format('DD-MMMM-YYYY')">
                <b>{{ event.date | prettyTime }}</b>
              </time><br>
              <time
                :datetime="date.format('DD-MMMM-YYYY')"
                v-if="event.end_date"><span class="is-size-6">{{ event.end_date | prettyTime }}</span></time>
            </p>
            <span
              class="dot is-medium"
              :class="rdvStatus.class">
              <span class="icon is-small has-text-white"><i :class="rdvStatus.icon"></i></span>
            </span>
          </div>
        </div>
        <div
          class="column is-padding is-flex"
          :class="{'is-border-right is-narrow' : hasStatus}"
          :style="{'max-width: 50%' : hasStatus}">
          <div class="is-self-centered">
            <div>
              <b>{{ event.rdv_type }}</b>&nbsp;-&nbsp;<span class="is-uppercase"><b><router-link
                v-if="currentRouterView !== 'ContactRdvs'"
                tag="a"
                :to="{name: 'ContactVue', params: {id: event.contact.pk}}">{{ event.contact.last_name }} {{ event.contact.first_name }}</router-link><span v-else>{{ event.contact.last_name }} {{ event.contact.first_name }}</span></b></span>
            </div>
            <div>
              Participant(s) :&nbsp;
              <router-link
                v-if="event.user.pk === currentUser.pk"
                :to="{name: 'UserVue', params: {id: event.user.pk}}">
                <span v-if="myCalendarStatus.value === 'Participant'">
                  Vous
                </span>
                <span v-else>
                  {{ event.user.last_name }} {{ event.user.first_name }}
                </span>
              </router-link>
              <span v-else>
                {{ event.user.last_name }} {{ event.user.first_name }}
              </span>
              <em class="has-text-grey">(Organisateur<span v-if="event.author && 'pk' in event.author && event.author.pk !== event.user.pk">: {{ event.author.last_name }} {{ event.author.first_name }}</span>)</em>
              <template v-if="event.guests && event.guests.length">
                <p
                  v-for="(guest, i) in event.guests"
                  :key="i">
                  <router-link
                    v-if="guest === currentUser.pk || isManager || isAdmin"
                    :to="{name: 'UserVue', params: {id: guest.pk === currentUser.pk ? currentUser.pk : guest.pk}}">
                    {{ guest.pk === currentUser.pk ? 'Vous' : guest.last_name + ' ' + guest.first_name }}
                  </router-link>
                  <span v-else>{{ guest.last_name }} {{ guest.first_name }} </span>
                  <em class="has-text-grey"> - Invité</em>
                </p>
              </template>
              <div
                class="is-padding-top-xsmall"
                v-if="event.address && (event.address.line1 !== null || event.address.zip_code !== null || event.address.city !== null)">
                <span class="icon is-small">
                  <i
                    class="fas fa-map-marked-alt"
                    :class="{'fa-spinner fa-spin':loading}"></i>
                </span>
                <span class="is-padding-left-xsmall">
                  {{ event.address.line1 }} {{ event.address.zip_code }} {{ event.address.city }}
                </span>
              </div>
              <span
                v-if="hasStatus"
                class="dot is-medium"
                :class="rdvStatus.class">
                <span class="icon is-small has-text-white"><i :class="rdvStatus.icon"></i></span>
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="hasStatus && open.qualification === false"
          class="column is-padding is-flex">
          <div class="is-self-centered">
            <div v-if="!isSuccessful">
              Bilan : <b class="is-uppercase">{{ rdvBilan }}</b>
            </div>
            <div v-else>
              {{ reportBlock[event.result].bilan.entitled }} : <b class="is-uppercase">{{ reportBlock[event.result].bilan.info }}</b>
            </div>
            <div
              v-if="hasReport && isDeferred"
              class="columns is-gapless">
              <div>
                Compte rendu : <b>
                  <a
                    v-if="!nextRdv"
                    @click="setNextRdv"
                    class="has-text-danger is-underline">Planifier nouveau rendez-vous</a>
                  <span v-if="nextRdv"> Nouveau rendez-vous <b>{{ nextRdv.rdv_type }}</b> fixé le
                    <router-link
                      class="is-underline"
                      tag="a"
                      :to="{name: 'CalendarDay', params: { year: nextRdv.year, month: nextRdv.month, day: nextRdv.day, panel: 'rdvs' }}">
                      <b> {{ nextRdv.date|date }}</b>
                    </router-link>
                  </span>
                </b>
              </div>
            </div>
            <div v-else-if="hasReport && isSuccessful && reportBlock[event.result].report">
              <span v-if="nextRdv">Compte rendu :
                Nouveau rendez-vous <b>{{ nextRdv.rdv_type }}</b> fixé le
                <router-link
                  class="is-underline"
                  tag="a"
                  :to="{name: 'CalendarDay', params: { year: nextRdv.year, month: nextRdv.month, day: nextRdv.day, panel: 'rdvs' }}">
                  <b> {{ nextRdv.date|date }}</b>
                </router-link>
              </span>
              <div v-else>
                {{ reportBlock[event.result].report.entitled }} :
                <b>
                  <a
                    v-if="reportBlock[event.result].report.is_link"
                    @click="setNextRdv"
                    class="has-text-danger is-underline">{{ reportBlock[event.result].report.info }}</a>
                  <span v-else>{{ reportBlock[event.result].report.info }}</span>
                </b>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="currentUser.account.pk === event.user.account.pk"
          class="column is-padding is-narrow is-self-centered">
          <div class="field is-grouped">
            <div class="control is-relative">
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <button
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    class="button is-actions is-circle">
                    <span class="icon is-small is-size-4"><i class="far fa-ellipsis-v"></i></span>
                  </button>
                </div>
                <div
                  id="dropdown-menu"
                  role="menu"
                  class="dropdown-menu">
                  <div class="dropdown-content">
                    <a
                      v-if="event.status === 'new'"
                      @click="open.qualification = true"
                      class="dropdown-item"><span class="icon is-medium"><i class="fas fa-calendar-check"></i></span><span>Qualifier</span></a>
                    <a
                      v-if="event.note"
                      @click="updateNote()"
                      class="dropdown-item"><span class="icon is-medium"><i class="fas fa-comment-alt-plus"></i></span><span>Modifier commentaire</span></a>
                    <a
                      v-else
                      @click="openNoteQuickview({}, event.pk)"
                      class="dropdown-item"><span class="icon is-medium"><i class="fas fa-comment-alt-plus"></i></span><span>Ajouter un commentaire</span></a>
                    <a
                      @click="getIcs(event)"
                      class="dropdown-item"><span class="icon is-medium"><i class="fas fa-upload"></i></span><span>Exporter (ics)</span></a>
                    <a
                      @click="updateRdv()"
                      class="dropdown-item"><span class="icon is-medium"><i class="fas fa-pencil"></i></span><span>Modifier rendez-vous</span></a>
                    <a
                      @click="deleteRdv()"
                      class="dropdown-item has-text-danger"><span class="icon is-medium"><i class="fas fa-trash"></i></span><span>Supprimer rendez-vous</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="open.qualification"
        class="day-eventactions is-border-top is-border--dashed">
        <div class="dayeventactions-actions">
          <div class="columns is-gapless">
            <div class="column is-narrow is-border-right control has-background-white">
              <label
                @click="qualification = 'successful'"
                :for="'qualify-successful-' + uuidv4"
                class="checkbox checkRadioIsHide">
                <input
                  type="radio"
                  value="successful"
                  :name="'qualify-successful-'"
                  :id="'qualify-successful-' + uuidv4">
                <span
                  class="tag is-xlarge is-size-1 is-radiusless is-padding-left is-padding-right"
                  :class="qualification === 'successful' ? 'is-success' : 'is-white'">
                  <span class="is-size-5">Effectué</span>
                </span>
              </label>
            </div>
            <div class="column is-narrow is-border-right control has-background-white">
              <label
                @click="qualification = 'deferred'"
                :for="'qualify-deferred-' + uuidv4"
                class="checkbox checkRadioIsHide">
                <input
                  type="radio"
                  value="deferred"
                  :name="'qualify-deferred-' + uuidv4"
                  :id="'qualify-deferred-' + uuidv4">
                <span
                  class="tag is-xlarge is-size-1 is-radiusless is-padding-left is-padding-right"
                  :class="qualification === 'deferred' ? 'is-warning' : 'is-white'">
                  <span class="is-size-5">Reporté</span>
                </span>
              </label>
            </div>
            <div class="column is-narrow is-border-right control has-background-white">
              <label
                @click="qualification = 'canceled'"
                :for="'qualify-canceled-' + uuidv4"
                class="checkbox checkRadioIsHide">
                <input
                  type="radio"
                  value="canceled"
                  :name="'qualify-canceled-' + uuidv4"
                  :id="'qualify-canceled-' + uuidv4">
                <span
                  class="tag is-xlarge is-size-1 is-radiusless is-padding-left is-padding-right"
                  :class="qualification === 'canceled' ? 'is-danger' : 'is-white'">
                  <span class="is-size-5">Annulé</span>
                </span>
              </label>
            </div>
            <div class="column is-narrow">
              <a
                @click="save(qualification)"
                class="button is-square is-large is-radiusless is-success is-actions is-height-full">
                <span class="icon is-size-4"><i class="fas fa-save"></i></span>
              </a>
            </div>
            <div
              @click="open.qualification = false"
              class="column is-narrow is-border-right">
              <a class="button is-square is-large is-radiusless is-light is-height-full">
                <span class="icon is-size-4"><i class="fas fa-times"></i></span>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-12 is-paddingless dayeventactions-actions"></div>
      </div>
      <div
        v-if="event.status === 'successful' && !event.result"
        class="day-eventactions is-border-top is-border--dashed">
        <div class="dayeventactions-actions">
          <div class="is-padding">
            Félicitation, dites-nous en plus. Votre contact est:
            <div class="columns is-gapless is-multiline is-margin-top-small">
              <div class="column is-11 is-9-widescreen is-padding-right-xsmall is-paddingless-bottom columns is-variable is-2 is-multiline">
                <div class="column is-4 is-3-widescreen is-paddingless-top is-paddingless-bottom is-padding-right-xsmall is-paddingless-left">
                  <input
                    v-model="report"
                    @click="reportChild = null"
                    value="interested"
                    type="radio"
                    :id="'interested_' + uuidv4"
                    :name="'interested_' + uuidv4"
                    class="vadCheckradiocase is-primary is-fullwidth"> <label
                      :for="'interested_' + uuidv4"
                      class="is-uppercase">Intéressé</label>
                </div>
                <div class="column is-4 is-3-widescreen is-paddingless-top is-paddingless-bottom is-padding-right-xsmall is-paddingless-left">
                  <input
                    v-model="report"
                    @click="reportChild = null"
                    value="not_interested"
                    type="radio"
                    :id="'not_interested_' + uuidv4"
                    :name="'not_interested_' + uuidv4"
                    class="vadCheckradiocase is-primary is-fullwidth"> <label
                      :for="'not_interested_' + uuidv4"
                      class="is-uppercase">Pas intéressé</label>
                </div>
                <div class="column is-4 is-3-widescreen is-paddingless-top is-paddingless-bottom is-padding-right-xsmall is-paddingless-left">
                  <input
                    v-model="report"
                    @click="reportChild = null"
                    value="of_target"
                    type="radio"
                    :id="'of_target_' + uuidv4"
                    :name="'of_target_' + uuidv4"
                    class="vadCheckradiocase is-primary is-fullwidth"> <label
                      :for="'of_target_' + uuidv4"
                      class="is-uppercase">Hors cible</label>
                </div>
              </div>
              <div
                v-if="report && report !== 'not_interested'"
                class="column is-8 is-padding-top-xsmall is-padding-right-xsmall columns is-variable is-2 is-multiline">
                <div
                  v-for="child of reportChildren[report]"
                  :key="child.label"
                  class="column is-3 is-paddingless-top is-padding-bottom-xsmall is-padding-right-xsmall is-paddingless-left">
                  <input
                    v-model="reportChild"
                    :value="child.value"
                    type="radio"
                    :id="child.value + '-' + uuidv4"
                    :name="child.value + '-' + uuidv4"
                    class="vadCheckradiocase is-primary is-fullwidth"> <label
                      :for="child.value + '-' + uuidv4"
                      class="is-uppercase">{{ child.label }}</label>
                </div>
              </div>
              <div
                v-if="canSubmitReport"
                class="column is-12 is-padding-right-xsmall is-padding-top is-paddingless-bottom-xsmall columns is-variable is-2 is-multiline">
                <p class="control">
                  <a
                    @click="save()"
                    class="button is-success">Enregistrer compte rendu</a>
                </p>
                <p
                  class="control is-margin-left-xxsmall"
                  v-if="!event.note">
                  <a
                    class="button is-info"
                    @click="openNoteQuickview({}, event.pk)"><span class="icon is-small is-padding-left-xxsmall"><i class="fas fa-comment-alt-plus is-size-5"></i></span><span class="is-transform-none">Ajouter un commentaire</span></a>
                </p>
                <p
                  class="control is-margin-left-xxsmall"
                  v-else>
                  <a
                    class="button is-info"
                    @click="openNoteQuickview({}, event.pk)"><span class="icon is-small is-padding-left-xxsmall"><i class="fas fa-comment-alt-plus is-size-5"></i></span><span class="is-transform-none">Modifier commentaire</span></a>
                </p>
                <p
                  @click="openReminder()"
                  class="control is-margin-left-xxsmall">
                  <a class="button is-danger has-hover-black"><span class="icon is-small is-padding-left-xxsmall"><i class="fas fa-alarm-clock is-size-5"></i></span><span class="is-transform-none">Programmer rappel</span></a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="event.note"
        class="day-eventactions is-border-top is-border--dashed">
        <div class="dayeventactions-actions">
          <div class="columns is-gapless is-padding">
            <p class="column is-narrow">
              <b>Commentaire :</b>
            </p> <p
              class="column is-padding-left-xsmall"
              v-html="event.note"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uuidv4 from 'uuid/v4'
import { Error, Quickview } from '@/mixins'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
const REPORT_BLOCK = {
  not_interested: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact pas intéréssé'
    },
    report: null
  },
  new_rdv: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'Planifier nouveau rendez-vous',
      is_link: true
    }
  },
  to_be_continued: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'À suivre',
      is_link: false
    }
  },
  plan_visit: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'Planifier rendez-vous visite',
      is_link: true
    }
  },
  sign: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'Planifier rendez-vous signature',
      is_link: true
    }
  },
  taxation: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Imposition',
      is_link: false
    }
  },
  age: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Âge',
      is_link: false
    }
  },
  period: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Période',
      is_link: false
    }
  },
  funding: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Financement',
      is_link: false
    }
  },
  no_offer: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Pas d\'offre',
      is_link: false
    }
  },
  other: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Autre',
      is_link: false
    }
  }
}
const REPORT_CHILDREN = {
  of_target: {
    taxation: { label: 'Imposition', value: 'taxation' },
    age: { label: 'Âge', value: 'age' },
    period: { label: 'Période', value: 'period' },
    funding: { label: 'Financement', value: 'funding' },
    no_offer: { label: 'PAs d\'offre', value: 'no_offer' },
    other: { label: 'Autre', value: 'other' }
  },
  interested: {
    new_rdv: { label: 'Nouveau rdv', value: 'new_rdv' },
    to_be_continued: { label: 'À suivre', value: 'to_be_continued' },
    plan_visit: { label: 'Planifier visite', value: 'plan_visit' },
    sign: { label: 'Signature', value: 'sign' }
  }
}
export default {
  name: 'CalendarRdvItems',
  mixins: [Error, Quickview],
  props: {
    event: {
      type: Object
    }
  },
  data () {
    return {
      nextRdv: null,
      loadingRdv: false,
      uuidv4: uuidv4(),
      reportBlock: REPORT_BLOCK,
      reportChildren: REPORT_CHILDREN,
      qualification: null,
      report: null,
      reportChild: null,
      open: {
        qualification: false
      }
    }
  },
  computed: {
    ...mapState(['currentUser', 'quickview']),
    ...mapGetters(['calendarRdv']),
    /**
       * date
       * @returns {date}
       */
    date () {
      let date = moment(this.event.date)
      if (date && date.isValid()) return date
      else return null
    },
    /**
       * current user status in event
       * @returns {object}
       */
    myCalendarStatus () {
      let status = {}
      if (this.currentUser.pk === this.event.user.pk) {
        status.value = 'Participant'
        status.tag = 'is-info'
      } else if ('guests' in this.event && this.event.guests.length && this.event.guests.includes(this.currentUser.pk)) {
        status.value = 'Invité'
        status.tag = 'is-optionne'
      }
      return status
    },
    /**
       * current rdv status
       * @returns {object}
       */
    rdvStatus () {
      let statusClass = {
        new: { class: 'is-border has-background-white', icon: '' },
        successful: { class: 'is-success', icon: '' },
        deferred: { class: 'is-warning', icon: '' },
        canceled: { class: 'is-danger', icon: '' }
      }
      if (this.event.result) {
        statusClass.successful.icon = 'fas fa-xs fa-check-circle'
      }
      return statusClass[this.event.status]
    },
    /**
       * rdv bilan
       * @returns {string}
       */
    rdvBilan () {
      let bilan = {
        deferred: 'Rendez-vous reporté',
        canceled: 'Rendez-vous Annulé'
      }
      return bilan[this.event.status]
    },
    /**
       * has status
       * @returns {boolean}
       */
    hasStatus () {
      if (this.event.status === 'successful') {
        return this.event.result
      } else {
        return this.event.status !== 'new'
      }
    },
    /**
       * has report
       * @returns {boolean}
       */
    hasReport () {
      return this.event.status !== 'new' && this.event.status !== 'canceled'
    },
    /**
       * can submit report
       * @returns {boolean}
       */
    canSubmitReport () {
      if (this.report === 'not_interested') {
        return true
      } else {
        return this.report && this.reportChild
      }
    },
    /**
       * event status is successful
       * @returns {boolean}
       */
    isSuccessful () {
      return this.event.status === 'successful'
    },
    /**
       * event status is deferred
       * @returns {boolean}
       */
    isDeferred () {
      return this.event.status === 'deferred'
    },
    /**
       * current router view
       * @returns {string} name of the route
       */
    currentRouterView () {
      return this.$route.name
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'NOTE_CREATE' && params.rdvPk === this.event.pk) {
        this.addNote(results.note)
      }
    }
  },
  created () {
    if (this.event.next_rdv) {
      this.getNextRdv()
    }
  },
  methods: {
    openReminder () {
      let source = {
        title: `Planifier nouveau rendez-vous avec ${this.event.contact.last_name} ${this.event.contact.first_name}`
      }
      let params = {
        contact: this.event.contact,
        noRedirection: true,
        source,
        type: 'reminder'
      }
      this.openCalendarNewAction(params)
    },
    async getIcs (event) {
      let { data } = await this.$api.get(`rdvs/${event.pk}/ical`)
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.download = `${event.title}.ics`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async getNextRdv () {
      this.loadingRdv = true
      let nextRdvAlreadyCharged = this.calendarRdv.find(rdv => {
        if (rdv.previous_rdv) return rdv.previous_rdv === this.event.pk
      })
      if (nextRdvAlreadyCharged) {
        let { data } = await this.$api.getOne(this.$resources.RDV, nextRdvAlreadyCharged.pk)
        this.nextRdv = Object.assign({}, data)
        this.nextRdv.year = moment(this.nextRdv.date).format('YYYY')
        this.nextRdv.month = moment(this.nextRdv.date).format('MM')
        this.nextRdv.day = moment(this.nextRdv.date).format('DD')
      } else {
        let params = {
          previous_rdv: this.event.pk,
          per_page: 1
        }
        let { data } = await this.$api.get(this.$resources.RDV, params)
        if (data.count > 0) {
          this.nextRdv = Object.assign({}, data.items[0])
          this.nextRdv.year = moment(this.nextRdv.date).format('YYYY')
          this.nextRdv.month = moment(this.nextRdv.date).format('MM')
          this.nextRdv.day = moment(this.nextRdv.date).format('DD')
        }
      }
      this.loadingRdv = false
    },
    updateRdv () {
      let params = {
        source: this.event,
        type: 'rdv',
        disableOtherTab: true
      }
      this.openCalendarNewAction(params)
    },
    setNextRdv () {
      let params = {
        previous: this.event.pk,
        source: this.event,
        type: 'rdv',
        disableOtherTab: true
      }
      this.openCalendarNewAction(params)
    },
    updateNote () {
      let note = {
        message: this.event.note
      }
      this.openNoteQuickview({ item: note }, this.event.pk)
    },
    async addNote (note) {
      try {
        await this.save(null, note.message)
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (err) {
        console.log(err)
      }
    },
    async save (qualification = null, note = null) {
      let rdv = Object.assign({}, this.event)
      if (qualification) {
        rdv.status = this.qualification
      }
      if (note || note === '') {
        rdv.note = note
      }
      rdv.contact = rdv.contact.pk
      rdv.user = rdv.user.pk
      if (this.report === 'not_interested') {
        rdv.result = 'not_interested'
      } else if (this.report) {
        rdv.result = this.reportChild
      }
      try {
        await this.$api.put(this.$resources.RDV, rdv.pk, rdv)
        if (this.$route.name !== 'ContactRdvs') {
          this.$emit('loadRdvs')
        } else {
          this.$emit('loadRdv', rdv.pk)
        }
        this.open.qualification = false
        this.$toasted.global.success('Le rendez-vous à été mis à jour.')
      } catch (err) {
        console.log(err)
        this.handleError(err)
      }
    },
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rendez-vous',
        text: 'Le rendez-vous ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteRdv () {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = this.event.pk
        let key = moment(this.event.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.RDV, eventPk)
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'rdvs' })
          this.$toasted.global.success('Le rendez-vous à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    },
    noteQuickview (type = 'create') {
      this.$store.commit('setQuickview', { mode: 'NOTE', params: { mode: type } })
    }
  }
}
</script>
